import React from "react";
import { Text, Icon } from "@artprov/design-system";

export default function Spinner({ label = "Cargando..." }) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40" aria-busy="true" aria-live="polite">
      <div className="flex flex-col items-center rounded-lg bg-white px-6 py-5 shadow-md">
        <Icon size="large" variant="loading" classNameIcon="text-[2rem] inline-flex items-center justify-center w-full h-full [&>*]:animate-spin" />
        <Text variant="subtitle1" className="mt-3 text-primary-10">
            {label}
        </Text>
      </div>
    </div>
  );
}
